import http from "./http";

export default {
  // 用户访问记录 oil/h5/guest_visit
  visitRecord(params) {
    return http.post("oil/h5/guest_visit", params);
  },

  // 品牌&热门品牌列表
  carBrandList(params) {
    return http.post("oil/h5/home", params);
  },

  // 根据图片获取vin码
  searchData(params) {
    return http.post("oil/h5/brands_list", params);
  },
  /**
   * 通过车辆照片识别车辆型号
   * @param {*} params
   * @returns
   */
  identifyVehicleByPhotoApi(params) {
    return http.post("oil/h5/vehicle_ai", params);
  },

  // 根据车辆获取车型
  choosType(params) {
    return http.post("oil/h5/models_list", params);
  },

  // 根据车辆销售名称
  chooseDisplacement(params) {
    return http.post("oil/h5/sales_name_list", params);
  },

  // 获取车辆款型年份
  chooseYear(params) {
    return http.post("oil/h5/product_year_list", params);
  },

  // 获取车辆ID
  getModelDetail(params) {
    return http.post("oil/h5/get_vehicle_id_new", params);
  },
  // getModelDetail(params) {
  //   return http.post("mock/oil/h5/get_vehicle_id", params);
  // },

  // 获取车辆信息详情
  getVehicleDetailApi(params) {
    return http.post("oil/h5/vehicle_detail", params);
  },

  // 获取机油推荐列表
  getOilRecommendGoodsListApi(params) {
    return http.post("oil/h5/recommend_goods_list", params);
  },
  // 获取机油商品详情
  getEngineOilGoodsDetailApi(params) {
    return http.post("oil/h5/recommend_goods_detail", params);
  },

  // 获取分享数据，配置
  getShareApi(params) {
    return http.post("oil/h5/share_info", params);
  },

  // vin码图片识别上传
  uploadVinApi(params) {
    return http.post("oil/h5/get_vehicle_id_new", params);
  },

  /*
   * 车辆配置
   * */
  //根据 levelId 获取车辆配置详情接口
  getConfig(params) {
    return http.get("front/car/detail", params);
  },
  /*
   * 保养推荐
   * */
  //根据 levelId 获取车辆保养推荐接口
  getMaintenance(params) {
    return http.post("front/car/by_mileage", params);
  },
  /*
   * 保养周期
   * */
  maintenanceCycle(params) {
    return http.get("front/cycle/list", params);
  },
  //原厂配件参数
  rawData(params) {
    return http.get("front/cycle/raw_data", params);
  },
  //其他保养数据参数
  upkeep(params) {
    return http.get("front/cycle/upkeep", params);
  },

  // 反馈
  feedbackApi(params) {
    return http.post("oil/h5/guest_book", params);
  },
  // 获取悬浮窗详情(悬浮窗曝光埋点)
  getFabDetailApi(params) {
    return http.post("oil/h5/floating_window/index", params);
  },
  // 悬浮窗点击埋点
  clickFabTrackingApi(params) {
    return http.post("oil/h5/floating_window/click", params);
  },
  // 获取Banner列表数据
  getBannerListApi(params) {
    return http.post("oil/h5/banner/list", params);
  },
  // Banner曝光埋点
  visitBannerTrackingApi(params) {
    return http.post("oil/h5/banner/exposure", params);
  },
  // 点击Banner埋点
  clickBannerTrackingApi(params) {
    return http.post("oil/h5/banner/click", params);
  },
  // 获取安心保落地页所需参数
  getLandingExtraParamsApi(params) {
    return http.post("oil/h5/landing/visit", params);
  },
  // 获取厂家车系列表
  getFactoryAndSeriesNameListApi(params) {
    return http.post("oil/h5/factory_alias_list_new", params);
  },
  // 获取车型排量列表
  getDisplacementListApi(params) {
    return http.post("oil/h5/displacement_list_new", params);
  },
  // 获取年份款型列表
  getYearsAndSalesNameListApi(params) {
    return http.post("oil/h5/year_sales_list_new", params);
  },
  // 获取发动机型号列表
  getCarEngineModels(params) {
    return http.post("oil/h5/engine_model_list_new", params);
  },
  // 获取开放菜单
  getValidMenusApi(params) {
    return http.post("oil/h5/home_menus", params);
  },
  // 获取F6保养灯复位的token
  getF6TokenApi(params) {
    return http.post("oil/h5/get_f6_token", params);
  },

  // 错误日志上报，排查问题
  setWebLogApi(params) {
    return http.post("oil/h5/web_log", params);
  },

  // 冷却液推荐商品列表
  getCoolantRecommendGoodsListApi(params) {
    return http.post("oil/h5/coolant_recommend_goods_list", params);
  },
  // 门店列表
  getStoreListApi(params) {
    return http.post("oil/h5/store_list", params);
  },
  // 点击备货助手埋点接口
  zhendaoClickEventApi(params) {
    return http.post("oil/h5/zhendao_click_event", params);
  },
  // 获取token
  getZhendaoTokenApi(params) {
    return http.post("oil/h5/zhendao_token", params);
  },
  // 获取省市区列表
  getRegionListApi(params) {
    return http.post("oil/h5/onedata_region_list", params);
  },
};
